import { render } from "./ReportGg.vue?vue&type=template&id=5f1bed30&scoped=true"
import script from "./ReportGg.vue?vue&type=script&lang=ts"
export * from "./ReportGg.vue?vue&type=script&lang=ts"

import "./ReportGg.vue?vue&type=style&index=0&id=5f1bed30&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f1bed30"

export default script